export const tuhocPrice = {
  DOLPRO_1M: '299.000đ',
  DOLPRO_6M: '1.479.000đ',
  DOLPRO_1M_SHORT: '299.000đ/ 1tháng',
  DOLPRO_1Y: '2.879.000đ',
};
